module.exports = __webpack_public_path__ + "static/media/52.c56d32e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/52.svg
// module id = 182
// module chunks = 0